import { integrationStatuses } from '@/configuration/pages/ConfigurationPage/IntegrationsConfigurations/constants'

export const integrationStatusLabels = {
  [integrationStatuses.pending]: 'Instalando…',
  [integrationStatuses.failed]: 'Instalación fallida',
}

export const nonToggleableStatuses = [
  integrationStatuses.pending,
  integrationStatuses.rejected,
  integrationStatuses.failed,
]
